import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getSupportedGrantEntitlementsLogsActions} from 'src/openapi/admin/apis/EntitlementLogDictionariesApi';
import {useAppDispatch} from 'src/store/hooks';

export const useGetEntitlementGrantActionTypeDictionary = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getSupportedGrantEntitlementsLogsActions(),
    ), [apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
